import {GET_NOTICE, UPDATE_NOTICE} from '../actions/notification/type';

const initState = {data_notice: [], count_notice: 0, order_count: 0}
export default function(state = initState, action){
    switch(action.type){
        case GET_NOTICE:
            return {...state, data_notice: action.payload.data, count_notice: action.payload.count, order_count: action.payload.orderCount}
        case UPDATE_NOTICE:
            return {...state, updateUserNotification: action.payload}
        default: 
            return {...state};
    }
}

